import { getReadableImageUrl } from "@/lib/directus";
import { sanitizeHTML } from "@/lib/utils";

interface LookingToTreatThisData {
  heading?: {
    text?: string;
    title?: string;
  };
  text?: {
    text?: string;
  };
  content_collection?: {
    id: string;
    site_content_collections_id: {
      collection: {
        collection: string;
        item: {
          // site_content fields
          title: string;
          text: string;
        };
      }[];
    };
  }[];
}

export const fields = [
  // headings
  "heading.text",
  "heading.title",

  // text
  "text.text",

  // content collection for nasal concerns
  "content_collection.id",
  "content_collection.site_content_collections_id.collection.collection",
  "content_collection.site_content_collections_id.collection.item:site_content.title",
  "content_collection.site_content_collections_id.collection.item:site_content.text",
] as const;

interface LookingToTreatThisProps {
  data?: LookingToTreatThisData;
}

export default function LookingToTreatThis({ data }: LookingToTreatThisProps) {
  // Handle null or undefined data gracefully
  if (!data) return null;

  return (
    <section className="w-full bg-white">
      <div className="container max-w-screen-2xl mx-auto px-8 py-8 xl:py-32">
        {/* Header Section */}
        <div className="max-w-4xl mx-auto mb-20 md:text-center text-left">
          <h2 className="text-[2rem] font-essonnes font-light leading-tight md:text-5xl lg:text-[3.375rem] text-primary mb-9">
            {data.heading?.text || data.heading?.title || ""}
          </h2>
          {data.text?.text && (
            <div 
              className="leading-normal text-[1rem] lg:text-[1.125rem] text-primary tracking-tight"
              dangerouslySetInnerHTML={sanitizeHTML(data.text.text)} 
            />
          )}
        </div>

        {/* Features Grid */}
        <div className={`flex flex-col md:flex-row gap-8 md:gap-16 md:overflow-x-auto md:pb-8 md:bader-h-scrollbar ${data.content_collection && data.content_collection.length <= 3 ? 'md:justify-center' : ''}`}>
          {data.content_collection?.map((collection, index) => {
            const titleItem = collection?.site_content_collections_id?.collection.find(item => item.collection === "site_content" && item.item.title)?.item;
            const textItem = collection?.site_content_collections_id?.collection.find(item => item.collection === "site_content" && item.item.text)?.item;
            
            const title = titleItem?.title || "";
            const text = textItem?.text || "";

            return (
              <div key={index} className="w-full md:flex-shrink-0 md:w-[20rem] flex flex-col gap-8">
                <h3 
                  className="text-[1.5rem] font-greycliff font-medium text-primary leading-[2rem] tracking-tight"
                  dangerouslySetInnerHTML={sanitizeHTML(title)}
                />
                <div 
                  className="text-primary font-light leading-normal text-[1rem] lg:text-[1.125rem] tracking-tight [&_a]:underline [&_p]:pb-4"
                  dangerouslySetInnerHTML={sanitizeHTML(text)} 
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
} 